import { render, staticRenderFns } from "./StationSimple.vue?vue&type=template&id=2ae62bb4&scoped=true"
import script from "./StationSimple.vue?vue&type=script&lang=js"
export * from "./StationSimple.vue?vue&type=script&lang=js"
import style0 from "./StationSimple.vue?vue&type=style&index=0&id=2ae62bb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae62bb4",
  null
  
)

export default component.exports